import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** Polls the count of nurse verbal orders awaiting this provider's co-signature. */
export function useVerbalOrders(intervalMs = 60000) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        let active = true;
        const fetchCount = () => Promise.all([
            api.get("/provider/verbal-orders/count").then((r) => r.data?.count || 0).catch(() => 0),
            api.get("/provider/verbal-orders/labs/count").then((r) => r.data?.count || 0).catch(() => 0),
        ]).then(([m, l]) => { if (active) setCount(m + l); });
        fetchCount();
        const id = setInterval(fetchCount, intervalMs);
        window.addEventListener("verbalorders:updated", fetchCount);
        return () => { active = false; clearInterval(id); window.removeEventListener("verbalorders:updated", fetchCount); };
    }, [intervalMs]);
    return count;
}
